import React from 'react';
import {useDispatch} from 'react-redux';
import {Actions} from '../../../common/actions';
import {Button, Modal} from 'semantic-ui-react';
import {TOYOTA_RUC} from '../../../common/constants/dealer';
import {downloadFile} from '../../../common/util/file';

const {
  addMessageBoxWarning,
  generateAccessoriesOrders,
  updateAccessoriesRequests,
  requestOrderToCpd,
} = Actions;

export const GenerateButton = (
  {buttonStatus, isCreationTab, chassisMarked, date, type, getOrdersStateFiltersValue}) => {
  const dispatch = useDispatch();

  function handleGenerateClick() {
    if (type === 'accessories') {
      const message = 'Las líneas de color rojo no serán procesadas, por falta de tareas asignadas.' +
        ' Tomar en cuenta que no se genera una nueva orden para los chasis que ya tienen una orden';
      dispatch(addMessageBoxWarning(message));
    }
    setTimeout(() => {
      const params = getOrdersStateFiltersValue();
      dispatch(generateAccessoriesOrders({date, type, 'chassis': chassisMarked}, params));
    }, 3000);
  }

  if (!chassisMarked.length || !isCreationTab) {
    return null;
  }

  return (
    <Button primary disabled={buttonStatus} onClick={handleGenerateClick}>Generar</Button>
  );
};

export const RequestButton = ({buttonStatus, isCreationTab, chassisMarked, date, type}) => {
  const dispatch = useDispatch();

  function handleRequestClick() {
    dispatch(updateAccessoriesRequests({'chassisList': chassisMarked}));
  }

  if (!chassisMarked.length || !isCreationTab || type !== 'accessories') {
    return null;
  }

  return (
    <Button primary disabled={buttonStatus} onClick={handleRequestClick}>Pedido</Button>
  );
};

export const RequestAccessoriesButton = ({
  buttonStatus, isCreationTab, chassisMarked, anticipated, type, getOrdersStateFiltersValue,
}) => {
  const dispatch = useDispatch();

  if (!chassisMarked.length || !isCreationTab || type !== 'accessories' || anticipated !== 'N') {
    return null;
  }

  function handleRequestClick() {
    const data = {
      'agency': '02',
      'dealer': TOYOTA_RUC,
      'chassis': chassisMarked.map((chassis) => ({'chassis': chassis})),
      'origin': 'acc-orders',
    };
    const params = getOrdersStateFiltersValue();
    dispatch(requestOrderToCpd(data, null, null, false, params));
  }

  return (
    <Modal
      trigger={<Button primary disabled={buttonStatus}>Pedido Acc.</Button>}
      header={'Confirmación Pedido de Accesorios'}
      content={<>
        <h3 style={{'textAlign': 'center', 'marginBottom': '0'}}>
          {`¿Está seguro que desea realizar el pedido de accesorios 
              para los ${chassisMarked?.length} vehículos seleccionados?`}</h3>
        <h5 style={{'textAlign': 'center', 'marginTop': '0', 'opacity': '0.45'}}>{`[${chassisMarked}]`}</h5>
      </>
      }
      actions={[
        {'key': 'cancel', 'content': 'Cancelar'},
        {'key': 'done', 'content': 'Confirmar', 'positive': true,
          'onClick': () => handleRequestClick(),
          'primary': true,
        },
      ]}
    />
  );
};

export const PrintButton = ({buttonStatus, isCreationTab, date, ordersMarked, type, orderStatusSelected}) => {
  function handlePrintClick() {
    const status = orderStatusSelected === 'ALL' ? '' : `&status=${orderStatusSelected}`;
    const baseUrl = process.env.REP_API_URL;
    const queryString = `date=${date}&type=${type}${status}&orders=${ordersMarked.join(',')}`;
    const fileUrl = `${baseUrl}/accessories/orders/documents?${queryString}`;
    downloadFile(fileUrl);
  }

  if (!ordersMarked.length || !isCreationTab) {
    return null;
  }

  return (
    <Button primary disabled={buttonStatus} onClick={handlePrintClick}>Imprimir</Button>
  );
};

